<template>
  <div>

    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <h2>Certificados</h2>
        </v-col>
      </v-row>
    </div>

    <div class="container-fluid">
      <v-layout row wrap>
        <v-col cols="12" sm="12">
          <v-card class="list-app">
            <v-card-title>
              Certificados de cursos concluídos
              <v-spacer></v-spacer>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :loading="loading"
              loading-text="Buscando certificados..."
              no-data-text="Nenhum certificado encontrado"
              :items="certificates"
              item-key="_id"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :options.sync="options"
              :page.sync="page"
              hide-default-footer
              :server-items-length="totalCertificates"
              class="elevation-3"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.download="{ item }">
                <v-btn
                  color="primary"
                  dark
                  small
                  @click="download(item)"
                >
                  Download
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-5 pb-5">
              <v-pagination
                v-model="page"
                :length="pageCount"
              />
            </div>
          </v-card>
        </v-col>
      </v-layout>
    </div>

    <v-dialog persistent v-model="downloading" width="500">
      <v-card class="persistent-custom">
        <v-card-text>
          <p>
            Gerando certificado
          </p>
          <div class="custom-loader-persistent"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
      dark
    >
      <v-row no-gutters>
        <v-col cols="12" class="text-center text-white">
          {{ alert.text }}
        </v-col>
        <!-- <v-col cols="2" class="text-right">
          <v-btn
            text
            icon
            x-small
            @click="alert.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col> -->
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
  import slugfy from 'slugify'

  export default {
    name: 'CertificateList',
    comments: [slugfy],
    data () {
      return {
        loading: false,
        downloading: false,
        headers: [
          { text: 'Curso', align: 'left', sortable: true, value: 'course' },
          // { text: 'Módulo', align: 'left', sortable: true, value: 'module' },
          { text: '', align: 'right', sortable: false, value: 'download' }
        ],
        certificates: [],
        totalCertificates: 0,
        sortBy: 'createdAt',
        sortDesc: true,
        page: 1,
        pageCount: 0,
        options: {
          itemsPerPage: 10
        },
        pagination: {
          rowsPerPage: 10,
          sortBy: 'createdAt',
          descending: true
        },
        alert: {
          show: false,
          text: null,
          color: null
        }
      }
    },
    watch: {
      options: {
        handler () {
          this.getCertificate()
        },
        deep: true,
      }
    },
    methods: {
      getCertificate () {
        this.loading = true
        this.axios.get('/user/certificate').then(response => {
          if (response.data.success) {
            this.certificates = response.data.certificates
            this.totalCertificates = response.data.certificates.length
          } else {
            this.alert.show = true
            this.alert.color = 'error'
            this.alert.text = response.data.message
          }
        }).catch(err => {
          console.error(err)

          this.alert.show = true
          this.alert.color = 'error'
          this.alert.text = 'Erro ao carregar os certificados'
        }).finally(() => {
          this.loading = false
        })
      },
      download (item) {
        this.downloading = true

        this.axios({
          url: `/user/certificate/file/${item._id}`,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          // console.log('response.data.size', response.data.size)
          // console.log('response', response)

          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', slugfy(item.course, '_') + '.pdf')
          document.body.appendChild(link)
          link.click()
        }).catch(err => {
          console.error(err)

          this.alert.show = true
          this.alert.color = 'error'
          this.alert.text = 'Erro ao gerar o certificado'
        }).finally(() => {
          this.downloading = false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .persistent-custom {
    // background-color: #fff;

    .v-card__text {
      padding: 15px;

      p {
        margin-bottom: 5px;
      }
    }

    .custom-loader-persistent {
      height: 4px;
      width: 100%;
      background-color: rgba(#2196f3, 0.2);

      &:after {
        content: '';
        display: block;
        height: 4px;
        width: 20%;
        background-color: #2196f3;
        opacity: 1;
        position: relative;
        animation: loader-move 2s ease infinite;
      }

      @keyframes loader-move {
        0%  {
          left: 0;
        }
        50% {
          left: 80%;
        }
        100% {
          left: 0;
        }
      }
    }
  }
</style>
